/**
 * Client mirror of the admin-api search limits (workers/admin-api/src/query.ts). Production D1
 * rejects a LIKE pattern over 50 bytes, so the Worker answers 400 query_too_long when the escaped
 * `%q%` pattern is longer; the search boxes check the same byte length (not `maxlength`, which
 * counts characters — 16 CJK characters already fill the 50 bytes) and say so before asking.
 */
export const LIKE_PATTERN_MAX_BYTES = 50;
/** The machine lookup accepts a whole SN or its tail: [A-Z0-9-], 4–64 characters. */
export const LOOKUP_MAX_CHARS = 64;
export const SEARCH_TOO_LONG = '搜尋字太長';

const utf8 = new TextEncoder();
export const utf8Bytes = (s: string): number => utf8.encode(s).length;

/** `%`, `_` and `\` escaped, exactly as the Worker does before binding the pattern. */
export const escapeLike = (q: string): string => q.replace(/[\\%_]/g, (c) => `\\${c}`);

/** True when the (trimmed) roster / audit / licence search would be refused by the Worker. */
export function searchTooLong(q: string): boolean {
  const t = q.trim();
  return t !== '' && utf8Bytes(`%${escapeLike(t)}%`) > LIKE_PATTERN_MAX_BYTES;
}

/** The lookup drawer's query as the Worker normalises it (upper-case, SN characters only). */
export const normalizeLookup = (q: string): string => q.toUpperCase().replace(/[^A-Z0-9-]/g, '');

export const lookupTooLong = (normalized: string): boolean => normalized.length > LOOKUP_MAX_CHARS;

/** Split a list into consecutive pieces of at most `size` (bulk calls are capped server-side). */
export function chunk<T>(items: readonly T[], size: number): T[][] {
  if (!Number.isInteger(size) || size < 1) throw new Error('chunk size must be a positive integer');
  const out: T[][] = [];
  for (let i = 0; i < items.length; i += size) out.push(items.slice(i, i + size));
  return out;
}
